export const ANY_ONE = '00000000-0000-0000-0000-000000000000';
export const I18nCalendar = {
	dayName : {
		sun : '日',
		mon : '月',
		tue : '火',
		wed : '水',
		thu : '木',
		fri : '金',
		sat : '土', 
	},
	today : '今日',
	monthFormat : 'M月YYYY',
	monthFormatOpt: 'YYYY年M月',
	monthFormatFull: 'YYYY年MM月',
	dateFormat: 'YYYY/MM/DD',
	dateFormatLong: 'YYYY-MM-DD',
	hourFormat: 'HH:mm',
	fullDate: 'YYYY年MM月DD日'
}
export const localeOptions = {
	longDateFormat : {
		LT : 'HH:mm',
		LTS : 'HH:mm:ss',
		L : 'YYYY/MM/DD',
		LL : 'D MMMM YYYY',
		LLL : 'D MMMM YYYY HH:mm',
		LLLL : 'dddd D MMMM YYYY HH:mm'
	},
	week: {
		dow: 7
	}
}

export const VALIDATION_RULE = {
	SHOPPER_CODE: {
		MAX: 20
	},
	FULL_NAME: {
		MAX: 30
	},
	DISPLAY_NAME: {
		MAX: 20
	},
	EMAIL: {
		REGEX: /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i,
		MAX: 200
	},
	PHONE_NUMBER: {
		REGEX: [/^(\+?([0-9]+$))/i,
			/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g,
			/^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/,
			/^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/g,
			/^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
		],
		MAX: 17
	},
	NOTE: {
		MAX: 1000
	},
	SPECIAL_CHARACTER: {
		REGEX: /[\<\>?~!@#\$%^&\*]+/i,
		REGEXDATE: /[\\!@#$%^&*()\-_,.?":{}|<>a-zA-Z]/g
	}
}
export const SCRIPT_RULE = {
	DETECT_SCRIPT : /<script[^>]*>.*?<\/script>/g,
	WHITE_SPACE: /(\r\n\t|\n|\r|\t)/gm,
	DETECT_SRC_SCRIPT : /src\s*=\s*(\"|')(([^\"';]*))(\"|')/g,	
	SRC_SCRIPT: /\S*src\s*=\s*\"(.*)\"/g,	
	CONTENT_SCRIPT:/<script.*?>(.*?)<\/script>/g
}